module.exports = {
  setPlacement: (state, str) => {
    state.placement = str
  },
  setPaymentType: (state, str) => {
    state.type = str
  },
  setPaymentId: (state, str) => {
    state.paymentId = str
  },
  setPaymentAccount: (state, obj) => {
    state.account = obj
  },
  setBilling: (state, arr) => {
    state.billing = arr
  },
  setGiftcards: (state, arr) => {
    state.giftcards = arr
  },
  setRewards: (state, arr) => {
    state.rewards = arr
  },
  setUpsells: (state, arr) => {
    state.upsells = arr
  },
  setUpsellImages: (state, arr) => {
    state.upsellImages = arr
  },
  setTipSelected: (state, str) => {
    state.tipSelected = str
  },
  setApplyDefaultTip: (state, bool) => {
    state.applyDefaultTip = bool
  },
  setGuestUser(state, obj) {
    state.guestUser = obj
  },
  setShowConfirmLocationPopUp: (state, bool) => {
    state.showConfirmLocationPopUp = bool;
  },
}
